/**
 * Created by nijin on 9/3/17.
 */
import { Injectable }   from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {GlobalService} from "../../../global/global.service";


@Injectable()
export class EventFormService {
  constructor(private gService: GlobalService) { }

  private isEmpty(obj){
    if(!obj){
      return true;
    }
    return Object.keys(obj).length === 0 && obj.constructor === Object
  }

  toFormGroup(attributes) {
    if (!attributes) {
      return new FormGroup({});
    }
    let attributeGroup = {};

    attributes.forEach(attribute => {
      attribute.value = this.gService.getValueByType(attribute);
      attributeGroup[attribute.name] = attribute.required ? new FormControl(attribute.value || '', Validators.required)
        : new FormControl(attribute.value || '');
    });
    return new FormGroup({attributes: new FormGroup(attributeGroup)});
  }

  locationToForm(location, values?, disabled?) {
    if (!location) {
       return new FormGroup({});
    }
    let attributeGroup = {};
    location.forEach(attribute => {
      if (attribute.datatype === this.gService.DATA_TYPE_JSON) {
        if (attribute.fields) {
          let fieldGroup = {};
          attribute.fields.forEach(field => {
            field.value = !this.isEmpty(values) ? values[attribute.name][field.name] : this.gService.getValueByType(field);
            fieldGroup[field.name] = field.required ? new FormControl(field.value, Validators.required)
              : new FormControl(field.value);
            disabled ? fieldGroup[field.name].disable() : fieldGroup[field.name].enable();
          });

          attributeGroup[attribute.name] = new FormGroup(fieldGroup);
        }
      } else {
        attribute.value = !this.isEmpty(values) ? values[attribute.name] : this.gService.getValueByType(attribute);
        attributeGroup[attribute.name] = attribute.required ? new FormControl(attribute.value, Validators.required)
          : new FormControl(attribute.value);
        disabled ? attributeGroup[attribute.name].disable() : attributeGroup[attribute.name].enable();
      }
    });
    return new FormGroup(attributeGroup);
  }


}



// WEBPACK FOOTER //
// ./src/app/things/things-details/event-simulation/event-form.service.ts